export default "__VITE_ASSET__f59e6e4d__"